export default {"src":"/_next/static/media/Videos-Icons.86dbe166.svg","height":27,"width":36};